/* src/app/location-users/users-search/users-search.component.scss */
.search.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e668" !important;
  color: #FFF;
}
.clear.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e67b" !important;
  color: #FFF;
}
/*# sourceMappingURL=users-search.component.css.map */
